// extracted by mini-css-extract-plugin
export default {"achievement":"Achievement_achievement__EzJ86","complete":"Achievement_complete__r+k8H"};